import React from 'react';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { styled } from '@mui/system';
import { Link } from 'react-router-dom';
import { SkillCategoryIcon } from 'utils/skillCategoryIcons';
import { getLocalizedPath } from 'helpers/getLocale';
import { getSkillSlug } from 'utils/seo';
import professionCases from 'helpers/professionCases';

const Title = styled(Typography)(({ theme }) => ({
  padding: '11px 25px 10px',
  fontSize: 24,
  textAlign: 'center',
  borderBottom: '1px solid #d6d6d6',
  [theme.breakpoints.down('md')]: {
    lineHeight: '34px'
  },
  [theme.breakpoints.down('sm')]: {
    textAlign: 'left'
  }
}));

const Wrapper = styled('div')(({ theme }) => ({
  borderRadius: 15,
  background: 'linear-gradient(180deg, #74bf14 0%, #68a718 100%)',
  maxWidth: 600,
  margin: '0 auto',
  [theme.breakpoints.down('md')]: {
    marginBottom: 20
  }
}));

const SkillButtonsWrapper = styled('div')(() => ({
  padding: '18px 25px',
  gap: '10px',
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  alignItems: 'center'
}));

const SkillButton = styled(Button)(({ theme }) => ({
  color: '#fff',
  borderColor: '#fff',
  borderWidth: '1px',
  borderRadius: 10,
  padding: '6px 18px',
  fontSize: 16,
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  '&:hover': {
    borderColor: '#fff',
    color: '#000',
    backgroundColor: '#fff',
    '& svg': {
      filter: 'brightness(0)'
    }
  },
  [theme.breakpoints.down('sm')]: {
    textAlign: 'left'
  }
}));

const CategoryIconWrapper = styled('span')(() => ({
  display: 'inline-flex',
  alignItems: 'center',
  flexShrink: 0,
  '& svg': {
    filter: 'brightness(0) invert(1)',
    fill: 'none !important',
    color: '#fff',
    stroke: '#fff',
    '& path, & circle, & rect, & polygon, & line': {
      fill: 'none !important',
      stroke: '#fff'
    }
  }
}));

const ContentContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: 'calc(100vh - 200px)',
  paddingTop: '20px'
}));

const SkillsSlideComponent = ({ professionInfo, t }) => {
  const skills = professionInfo?.skills || [];

  // Hide component if no skills
  if (!skills.length) {
    return null;
  }

  // Get skill URL. getSkillSlug reads the current locale and picks the
  // matching name field, falling back through en → uk.
  const getSkillUrl = (skill) => getLocalizedPath(`/skills/${getSkillSlug(skill)}/${skill._id}`);

  return (
    <>
      <Title variant={'h1'}>
        {t('MainSkillsTitle', professionCases(professionInfo, 'genitive'))}
      </Title>

      <ContentContainer>
        <Wrapper>
          <SkillButtonsWrapper>
            {skills.map((skill) => {
              return (
                <SkillButton
                  component={Link}
                  to={getSkillUrl(skill)}
                  key={skill?._id}
                  variant="outlined">
                  <CategoryIconWrapper>
                    <SkillCategoryIcon skill={skill} size={20} />
                  </CategoryIconWrapper>
                  {skill.name}
                </SkillButton>
              );
            })}
          </SkillButtonsWrapper>
        </Wrapper>
      </ContentContainer>
    </>
  );
};

export default SkillsSlideComponent;
